/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { xScreen } from "@eisinc/XDL/Utilities";
import { requisitionConfirmationPageContainerStyles } from "@insite/content-library/Widgets/RequisitionConfirmation/RequisitionConfirmationPageContainer";
import { css } from "styled-components";

requisitionConfirmationPageContainerStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 317px);
        gap: 22px;
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
        }
    `,
};

requisitionConfirmationPageContainerStyles.cartLinesContainer = {
    css: css`
        order: 1;
    `,
};

requisitionConfirmationPageContainerStyles.totalContainer = {
    css: css`
        order: 2;
    `,
};
